import { Component, input, OnInit, output, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslatePipe } from '@ngx-translate/core';

import momentTimezones from 'moment-timezone';
import { AsyncAutocompleteComponent } from '../async-autocomplete/async-autocomplete.component';

type Timezone = { key: string; value: string };

@Component({
  imports: [AsyncAutocompleteComponent, TranslatePipe, FlexLayoutModule],
  selector: 'iot-platform-ui-timezone-autocomplete',
  templateUrl: './timezone-autocomplete.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./timezone-autocomplete.component.scss']
})
export class TimezoneAutocompleteComponent implements OnInit {
  placeholder = input<string>('IOT_DICTIONARY.TIMEZONE');
  initialItem = input<string | null>(null);
  clearOnSelect = input<boolean>(true);
  required = input<boolean>(false);
  disabled = input<boolean>(false);
  disableOnlyOptions = input<boolean>(false);
  displayOffset = input<boolean>(false);
  errorMessage = input<string>();

  selectionChange = output<string>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  reset = output<void>();

  timezones: WritableSignal<Timezone[]> = signal([]);
  selectedTimezone: WritableSignal<Timezone | undefined> = signal(undefined);
  filteredTimezones: WritableSignal<Timezone[]> = signal([]);

  ngOnInit(): void {
    this.timezones.set(
      momentTimezones.tz.names().map((timezone: string) => ({
        key: this.displayOffset() ? `${timezone} ${momentTimezones.tz(timezone).format('Z')}` : timezone,
        value: timezone
      }))
    );

    this.filteredTimezones.set([...this.timezones()]);
    this.selectedTimezone.set([...this.timezones()].find(({ value }) => value.toLowerCase().trim() === this.initialItem()?.toLowerCase().trim()));
  }

  onSearch(timezone: string): void {
    this.filteredTimezones.set(this.timezones().filter(({ key }) => key.toLowerCase().includes(timezone.toLowerCase())));
  }

  onReset(): void {
    this.filteredTimezones.set([...this.timezones()]);
    this.selectedTimezone.set(undefined);
    this.reset.emit();
  }

  onSelect(selected: Timezone): void {
    if (selected) {
      this.selectionChange.emit(selected.value);
    }
  }
}
